import { inject } from '@angular/core';
import {
    CanActivateFn,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { PermissionsService } from './permissions.service';

export const PermissionGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const router: Router = inject(Router);
    const _permissionService = inject(PermissionsService);

    const requiredPermission = route.data['permission'] as string | undefined;

    if (!requiredPermission) {
        return of(true);
    }
    if (!_permissionService.hasPermission(requiredPermission)) {
        const urlTree = router.parseUrl('/error-403');
        return of(urlTree);
    }

    return of(true);
};
